'use client';

import dynamic from 'next/dynamic';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import MetaTags from '@/components/meta-tag/meta-tag';
import TechnologyFaq from '@/components/technologies/technology-faq';
import Blog from '@/components/home/blog';
import HireProcessAimlDev from '@/components/technologies/hire-process-aimldev';
import LlmsProductionReadySolutions from '@/components/common/llms-productionready-solution';
import ValueProposition from '@/components/home/value-proposition';
import WhyRAG from '@/components/home/why-rag';
import OurOfferingsRag from '@/components/common/our-offeringsrag';
import TechnicalApproach from '@/components/common/technical-approach';
import ArchitectureDiagram from '@/components/common/architecture-diagram';
import IntegrationsTech from '@/components/common/integrations-tech';
import LlmsTechStack from '@/components/home/llms-tech-stack';
import WhyLLMs from '@/components/home/why-llms';
import LlmsConversationalFAQ from '@/components/faqs/llms-conversational-faq';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroLlmsConversational = dynamic(() => import('@/components/technologies/tech-hero-llms-conversational'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <div className="dark:bg-black">
                <TechHeroLlmsConversational />
                <LlmsProductionReadySolutions />
                <ValueProposition />
                <WhyRAG />
                <OurOfferingsRag />
                <TechnicalApproach />
                <ArchitectureDiagram />
                <IntegrationsTech />
                <LlmsTechStack />
                <HireProcessAimlDev
                    bg="bg-black"
                    pageTitle="Our AI/ML Development Process"
                    desc="Maximize the possibilities of the newest AI/ML version. You can hire our AI/ML developers, who are competent in the technical and interactive abilities required to meet your project's objectives."
                />
                <WhyLLMs />
                <TechnologyFaq title="FAQs for LLM and RAG Solutions" bg="bg-aiml-faq">
                    <LlmsConversationalFAQ />
                </TechnologyFaq>
                <CaseStudies />
                <section className="">
                    <ClientTestimonials />
                </section>
                <Blog />
                <div className="section bg-primary py-100 dark:text-light dark:bg-black dark:pt-1">
                    <div className="container lg:container md:mx-auto">
                        <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                            <ContactForm />
                            <ContactInfo />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
